import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ProcessesTable } from '../../common/types/types';

interface CompaniesState {
  reachedProcesses: ProcessesTable[];
}

const initialState: CompaniesState = {
  reachedProcesses: [],
};

const processesSlice = createSlice({
  name: 'processes',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setReachedProcesses: (state, action: PayloadAction<ProcessesTable[]>) => {
      return { ...state, reachedProcesses: action.payload };
    },
  },
});

export const { reset, setReachedProcesses } = processesSlice.actions;
export default processesSlice.reducer;
